import React from "react";
//import { Link } from "react-router-dom";

function CardItem(props) {
  var descContainer = "";
  if (props.description !== "") {
    descContainer = (
      <div className="cards__item__info">
        <h5 className="cards__item__text">{props.text}</h5>
        <p className="cards-desc">{props.description}</p>
        <br></br>
        <span className="viewmore">View More</span>
      </div>
    );
  } else {
    descContainer = (
      <div className="cards__item__info">
        <h5 className="cards__item__text">{props.text}</h5>
        <span className="viewmore">View More</span>
      </div>
    );
  }
  return (
    <>
      <li className="cards__item">
        {/* <Link className="cards__item__link" to={props.path}> */}
        <a className="cards__item__link" href={props.path}>
          <figure className="cards__item__pic-wrap" data-category={props.label}>
            <img
              className="cards__item__img"
              alt={props.text}
              src={props.src}
            />
          </figure>
          {descContainer}
        </a>
      </li>
    </>
  );
}

export default CardItem;
